import styled from 'styled-components'

import theme from 'theme_'
import { H1 } from 'components/Typography/Headings'

export const PowerCardsWrapper = styled.div`
  display: flex;
`

export const LoadCellWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`

export const LoadStatusWrapper = styled.div`
  margin-top: 32px;
`

export const LoadStatusHeader = styled(H1)`
  margin-bottom: 16px;
`

export const OnState = styled.span`
  color: ${theme.colors.horizonOrange};
`

export const LoadStatusSearchWrapper = styled.div`
  margin-bottom: 16px;
`

export const LoadSpan = styled.span`
  color: ${theme.colors.otterWarmBlack};
  font-weight: 700;
`
